import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation StartCOCampaign($id: ID!) {
    startContinuousOptimizationCampaign(id: $id) {
      id
      status
    }
  }
`;

export function startCOCampaign(id) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
}
